<template>
  <v-dialog
    v-model="isDialogOpen"
    max-width="600px"
    scrollable
    retain-focus
    @keydown.esc="closeDialog"
  >
    <!-- pass through activator slot -->
    <template v-slot:activator="slotData">
      <slot v-if="$scopedSlots.activator" name="activator" v-bind="slotData" />
    </template>

    <v-card :loading="isLoading">
      <v-card-title class="headline">
        Alert History Details
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="overflow-y-auto">
        <v-skeleton-loader :loading="isLoading" type="article">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6" class="pt-0">
                  <v-text-field
                    v-model="sentAtDateTimeFormatted"
                    label="Date/Time Sent"
                    outlined
                    dense
                    readonly
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="pt-3 pt-sm-0">
                  <v-text-field
                    v-model="historyEntry.sentByUserFullName"
                    label="Sent By"
                    outlined
                    dense
                    readonly
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="historyEntry.message"
                    label="Message"
                    rows="3"
                    outlined
                    dense
                    readonly
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-title class="subtitle-1 font-weight-bold">
            Delivery Report
            <v-spacer></v-spacer>
            <PercentageChip :value="historyEntry.deliveryPercent">
              <template v-slot:before-percentage>
                Confirmed Deliveries:
              </template>
            </PercentageChip>
          </v-card-title>

          <v-card-text>
            <v-container class="pt-0">
              <v-row>
                <v-col cols="12" class="pt-0">
                    <v-data-table
                        :headers="deliveryReportHeaders"
                        :items="historyEntry.recipientStatuses"
                        :sort-by="['recipientFullName']">
                        <template v-slot:item.statusUpdatedAtDateTime="{ item }">
                            {{ formatShortDateTime(item.statusUpdatedAtDateTime) }}
                        </template>
                    </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-skeleton-loader>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store/store";
import moment from "moment";
import { HistoryEntry } from "@/store/modules/messaging";
import PercentageChip from '@/components/PercentageChip'

export default {
  name: "HistoryDetailsDialog",
  components: {
    PercentageChip
  },
  props: {
    historyId: {
      type: [Number, String],
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isDialogOpen: true,
    isLoading: true,
    historyEntry: new HistoryEntry(),
    deliveryReportHeaders: [
      { text: "Subscriber", value: "recipientFullName" },
      { text: "Phone #", value: "recipientPhoneNumber" },
      { text: "Status", value: "statusName" },
      { text: "Updated", value: "statusUpdatedAtDateTime" }
    ]
  }),
  computed: {
    sentAtDateTimeFormatted() {
      if (!this.historyEntry) {
        return "";
      }

      return moment(this.historyEntry.sentAtDateTime).format("llll");
    }
  },
  watch: {
    isDialogOpen: function (newValue) {
      if (!newValue) {
        this.$router.push({ name: "History" });
        this.$emit("input", false);
      }
    },
  },
  methods: {
      formatShortDateTime(dt) {
        return moment(dt).format('l LTS')
      },
    closeDialog() {
      this.isDialogOpen = false;
    },
    ...mapActions("snackbar", ["showSnackbar"]),
  },
  beforeRouteEnter(to, from, next) {
    const loadDataPromise = new Promise((resolve, reject) => {
      const historyId = to.params.historyId;
      store
        .dispatch("messaging/getHistory", historyId)
        .then((historyEntry) => {
          resolve(historyEntry);
        })
        .catch((err) => {
          reject(err);
        });
    });

    next((vm) => {
      vm.isLoading = true;

      loadDataPromise
        .then((result) => {
          vm.historyEntry = result;
        })
        .catch((err) => {
          store.dispatch("snackbar/showSnackbar", {
            message: err.message,
            color: "error",
          });
        })
        .finally(() => {
          vm.isLoading = false;
        });
    });
  },
};
</script>
